/**
 * @desc 保存
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.platformLogistics.save.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformLogistics/save`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
